<template>
  <div class="canvas-box" ref="canvasBox">
    <div class="canvas-item left-top" ref="canvasItem1">
      <div>
        <label>[上次学到的{{ typeName }}]</label>
        <div class="td-fcc">
          <span>{{ dataSource.name || '无数据' }}</span>
        </div>
      </div>
    </div>
    <div class="canvas-item right-top" ref="canvasItem2">
      <div>
        <label>[正在学习的课程]</label>
        <div class="td-fcc">
          <img src="https://www.word007.com/images/basic/book.png">
          <span>{{ dataSource.curriculum || '无数据' }}</span>
        </div>
      </div>
    </div>
    <div class="canvas-item left-bottom" ref="canvasItem3">
      <div>
        <div class="td-fcc">
          <span>{{ dataSource.status == 1 ? '已完成' : '未完成' }}</span>
        </div>
        <label>[状态]</label>
      </div>
    </div>
    <div class="canvas-item right-bottom" ref="canvasItem4">
      <div>
        <div class="td-fcc">
          <span>{{ dataSource.study_date || '无数据' }}</span>
        </div>
        <label>[上次学习时间]</label>
      </div>
    </div>
    <div class="canvas-center td-fcc unit-btn" ref="canvasCenter" @click="openStudy(dataSource.unit_id)">
      <span>{{ dataSource.unit || '无数据' }}</span>
    </div>
    <div class="line-box" ref="LineBox"></div>
    <dynamic-box
        :windowStatus="windowStatus"
        :data="wordStudyStage.dataSource"
        :type="wordStudyStage.type"
        @callBack="callBack">
    </dynamic-box>
    <dynamic-box-g
        :windowStatus="windowStatusGrammar"
        :data="studyStage.dataSource"
        :type="studyStage.type"
        @callBack="callBackGrammar">
    </dynamic-box-g>
  </div>
</template>

<script>
import Lockr from "lockr";
import {mapState, mapGetters, mapMutations} from 'vuex';
import dynamicBox from "../../views/words/templates/dynamicBox";
import dynamicBoxG from "../../views/grammar/templates/dynamicBox";

import {selectUnit,} from '@/api/words'
import {httpPost} from "@/http/axios";

export default {
  name: "study-home-canvas",
  props: {
    dataSource: {}
  },
  components: {dynamicBox,dynamicBoxG},
  computed: {
    ...mapGetters(['wordStudyStage']),
    ...mapGetters(['studyStage'])
  },
  data() {
    return {
      typeName: '',
      atUnit:'',
      windowStatus: false,
      windowStatusGrammar: false
    };
  },
  methods: {
    ...mapMutations(['CHANGE_WORD_STUDY_TYPE']),
    ...mapMutations(['CHANGE_STUDY_TYPE']),
    callBack(data) {
      if (data.type == 'close') {
        this.windowStatus = false;
      }
    },
    callBackGrammar(data) {
      if (data.type == 'close') {
        this.windowStatusGrammar = false;
      }
    },
    openStudy(id) {
      if (this.typeName == '单词') {
        this.openWordWin(id)
      }else if(this.typeName=="语法"){
        this.openGrammarWin(id)
      }
    },
    async openWordWin(id) {
      let params = {
        token: Lockr.get('token'),
        unit_id: id
      }
      let result = await selectUnit(params)
      if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
        this.atUnit = result.data
        let data = {
          type: 'wordStudy/wordIdentify',
          title: '单词学习',
          dataSource: this.atUnit,
          courseType: 'dcxx',
        }
        data.dataSource.unit_id = id
        data.dataSource.curriculum_name += name
        this.CHANGE_WORD_STUDY_TYPE(data)
        this.windowStatus = true
      } else {
        this.$message({
          message: result.msg,
          type: 'warning'
        });
      }
    },
    async openGrammarWin(id) {
      let params = {
        token: Lockr.get('token'),
        unit_id: id
      }
      let result = await httpPost('/api/grammar/choice_unit', params, '选择语法学习单元')
      if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
        this.atUnit = result.data
        let data = {
          title: '语法学习',
          type: 'yufa/yfGrammarStudy',
          dataSource: this.atUnit,
          courseType: 'yfxx',//语法类型
          closeBtn: false,
          unitType: this.type,
          position: result.data.position || 1
        }
        data.dataSource.unit_id = id
        data.dataSource.curriculum_name += name
        this.CHANGE_STUDY_TYPE(data)//弹出强制复习
        this.windowStatusGrammar = true
      } else {
        this.$alert(result.msg, '温馨提示', {
          confirmButtonText: '确定'
        });
      }
    },
    // tool
    getDomCenterCoordinate(dom) {
      let top = dom.offsetTop
      let left = dom.offsetLeft
      let height = dom.offsetHeight
      let width = dom.offsetWidth
      let x = left + width / 2
      let y = top + height / 2
      return {
        x,
        y
      }
    },
    getTwoDomCenterDistance(dom) {
      let canvasBox = this.$refs.canvasBox
      let x = canvasBox.offsetWidth / 2
      let y = canvasBox.offsetHeight / 2
      let o1 = this.getDomCenterCoordinate(dom)
      let dx = o1.x - x
      let dy = o1.y - y
      let w = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2))
      let atan = Math.abs(dy) / Math.abs(dx);
      let radina = Math.atan(atan); //用反三角函数求弧度
      let angle = Math.floor(180 / (Math.PI / radina)); //将弧度转换成角度
      //在第一象限
      if (dx > 0 && dy > 0) {
        angle = angle;
      }
      //在第二象限
      if (dx < 0 && dy > 0) {
        angle = 180 - angle;
      }
      //在第三象限
      if (dx < 0 && dy < 0) {
        angle = 180 + angle;
      }
      //在第四象限
      if (dx > 0 && dy < 0) {
        angle = -angle;
      }
      return {
        width: w,
        angle
      }
    },
    drawline() {
      let canvasBox = this.$refs.canvasBox
      let LineBox = this.$refs.LineBox
      let Doms = [this.$refs.canvasItem1, this.$refs.canvasItem2, this.$refs.canvasItem3, this.$refs.canvasItem4]
      let o = {
        x: canvasBox.offsetWidth / 2,
        y: canvasBox.offsetHeight / 2
      }
      LineBox.innerHTML = ""
      Doms.map((item) => {
        let newDiv = document.createElement('div')
        let d = this.getTwoDomCenterDistance(item)
        newDiv.style.cssText += `transform-origin:0 50%;transform:rotate(${d.angle}deg);width:${d.width}px;top:${o.y}px;left:${o.x}px;position: absolute;height: 5px;background-color: #eee;`
        LineBox.appendChild(newDiv)
      })
    }
  },
  watch: {
    dataSource: {
      handler(newVal, oleVal, c) {
        this.drawline()
      },
      deep: true // 必须加这个属性
    }
  },
  mounted() {
    window.onresize = () => {
      this.drawline()
    }
    this.drawline()
  },
  created() {
    this.typeName = this.$route.meta.type == 'word' ? '单词' : '语法'
  }
};
</script>

<style scoped lang='less'>
.canvas-box {
  position: relative;
  width: 100%;
  height: 500px;
  padding: 50px 0;

  .canvas-item {
    position: absolute;
    z-index: 1;

    > div {
      position: relative;

      label {
        color: #999;
        font-size: 12px;
        position: absolute;
        display: block;
        min-width: 130px;
      }

      > div {
        padding: 15px 20px;
        font-size: 16px;
        color: #fff;
        font-weight: 700;
        background-color: #fa7f4f;
        border-radius: 4px;
        max-width: 260px;
        min-width: 120px;
        min-height: 60px;
        box-sizing: border-box;
        text-align: justify;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
        img {
          display: block;
          width: 26px;
          height: 26px;
          margin-right: 10px;
        }
      }
    }
  }

  .left-top {
    top: 15%;
    left: 10%;

    label {
      top: -20px;
      left: 0;
    }
  }

  .right-top {
    top: 10%;
    right: 5%;

    label {
      top: -20px;
      right: 0;
    }
  }

  .left-bottom {
    bottom: 15%;
    left: 12%;

    label {
      bottom: -20px;
      left: 0;
    }
  }

  .right-bottom {
    bottom: 10%;
    right: 10%;

    label {
      bottom: -20px;
      right: 0;
    }
  }

  .right-top,
  .right-bottom {
    label {
      text-align: right;
    }
  }

  .canvas-center {
    background: rgba(51, 209, 71, 1);
    height: 100px;
    width: 200px;
    border-radius: 4px;
    font-size: 26px;
    color: #fff;
    font-weight: 700;
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    margin-top: -50px;
    margin-left: -100px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
  }
}

.unit-btn {
  cursor: pointer;
  transition: all .3s;
}

.unit-btn:hover {
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.5);
}

@media (min-width: 1200px) {
  .canvas-box {
    .canvas-item {
      > div {
        label {
          font-size: 16px !important;
        }

        > div {
          padding: 10px 20px;
          font-size: 18px;
          font-weight: 600;
        }
      }
    }
  }
}
</style>